import { Component, OnInit } from "@angular/core";
import { UnSubscriber } from "@mobi-office-ui";
import { ICONS } from "../../models/svg-icons";

@Component({
  selector: "mobi-office-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrl: "./dashboard.component.scss",
  standalone: false,
})
export class DashboardComponent extends UnSubscriber implements OnInit {
  constructor() {
    super();
  }

  readonly ICONS = ICONS;
  ngOnInit(): void {}
}
